import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Heading,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { Link, useNavigate, useParams } from "react-router-dom";
import { adminUpdateComic, getAdminComic } from "../../../services/adminApi";
import Spinner from "../../../shared/components/Spinner";
import { Card } from "../../auth/components/Login/Card";
import ComicForm from "../components/ComicForm";

function ComicUpdate() {
  const navigate = useNavigate();
  const { id } = useParams();
  const queryClient = useQueryClient();
  const comicId = id;
  const toast = useToast();
  const { data, isLoading, isError, isSuccess } = useQuery(
    ["comic", comicId],
    () => getAdminComic(comicId),
    {
      refetchOnWindowFocus: false,
    }
  );

  const { mutateAsync } = useMutation((values) => {
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("description", values.description);
    formData.append("franchise", values.franchise);
    if (values.thumbnail) {
      formData.append("thumbnail", values.thumbnail);
    }

    return adminUpdateComic(comicId, formData);
  });

  // Handle form submit
  async function handleSubmit(values) {
    mutateAsync(values)
      .then(() => {
        toast({
          title: "Comic updated.",
          description: "The comic information has been updated.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        queryClient.invalidateQueries(["comic", comicId]);
        navigate("/comics/all");
      })
      .catch((error) => {
        console.error(error);
        // handle error
        toast({
          title: "Error occurred",
          description:
            error.response?.data?.message || "The comic could not be updated.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      });
  }

  return (
    <Box
      bg={useColorModeValue("gray.50", "inherit")}
      minH="100vh"
      py="12"
      px={{ base: "4", lg: "8" }}
    >
      <Box maxW="xl" mx="auto">
        <Breadcrumb mb="3">
          <BreadcrumbItem>
            <BreadcrumbLink as={Link} to="/comics/all">
              Comics
            </BreadcrumbLink>
          </BreadcrumbItem>

          <BreadcrumbItem isCurrentPage>
            <BreadcrumbLink>Update: {data?.data?.title}</BreadcrumbLink>
          </BreadcrumbItem>
        </Breadcrumb>

        <Card>
          {isLoading && <Spinner />}
          {isError && <p>Error</p>}
          {isSuccess && (
            <>
              <Heading as="h2" mb="6">
                Update: {data?.data?.title}
              </Heading>
              <ComicForm comic={data.data} handleSubmit={handleSubmit} />
            </>
          )}
        </Card>
      </Box>
    </Box>
  );
}

export default ComicUpdate;
